import React, { useState } from 'react';

const Login = ({ onLogin }) => {
  const [credentials, setCredentials] = useState({
    username: '',
    password: ''
  });
  const [error, setError] = useState('');
  const [isLogging, setIsLogging] = useState(false);

  // Production credentials
  const validUsers = {
    'ctk': 'Royals@6802',
    'mvp': 'Bridge64',
    'vcokley': 'z84q91',
    'jarbitello': 'e29v30'
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setIsLogging(true);
    setError('');

    // Simple delay to show loading state
    setTimeout(() => {
      // Make username case-insensitive by converting to lowercase
      const username = credentials.username.toLowerCase();
      const password = credentials.password;
      
      if (validUsers[username] === password) {
        // Pass the original username (with original case) to maintain display
        onLogin(credentials.username);
      } else {
        setError('Invalid username or password');
      }
      setIsLogging(false);
    }, 500);
  };

  return (
    <div className="min-h-screen bg-gray-100 flex items-center justify-center p-4">
      <div className="max-w-md w-full bg-white rounded-xl shadow-lg p-8">
        <div className="text-center mb-8">
          <div className="text-4xl mb-4">🔐</div>
          <h1 className="text-3xl font-bold text-gray-800 mb-2">Security System</h1>
          <p className="text-gray-600">Please log in to continue</p>
        </div>

        <form onSubmit={handleSubmit} className="space-y-6">
          <div>
            <label className="block text-lg font-medium text-gray-700 mb-3">
              Username
            </label>
            <input
              type="text"
              value={credentials.username}
              onChange={(e) => setCredentials({...credentials, username: e.target.value})}
              className="w-full px-4 py-4 text-lg border-2 border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
              placeholder="Enter your username"
              required
            />
          </div>

          <div>
            <label className="block text-lg font-medium text-gray-700 mb-3">
              Password
            </label>
            <input
              type="password"
              value={credentials.password}
              onChange={(e) => setCredentials({...credentials, password: e.target.value})}
              className="w-full px-4 py-4 text-lg border-2 border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
              placeholder="Enter your password"
              required
            />
          </div>

          {error && (
            <div className="bg-red-50 border border-red-200 rounded-lg p-4">
              <p className="text-red-800 font-medium">❌ {error}</p>
            </div>
          )}

          <button
            type="submit"
            disabled={isLogging}
            className={`w-full py-4 text-xl font-semibold rounded-lg transition-colors ${
              isLogging
                ? 'bg-gray-400 text-gray-600 cursor-not-allowed'
                : 'bg-blue-500 text-white hover:bg-blue-600'
            }`}
          >
            {isLogging ? 'Logging In...' : 'Log In'}
          </button>
        </form>

        <div className="mt-8 p-4 bg-blue-50 border border-blue-200 rounded-lg">
          <h3 className="font-semibold text-blue-800 mb-2">Access Information:</h3>
          <div className="text-sm text-blue-700">
            <p>• Contact your administrator for login credentials</p>
            <p>• Usernames are not case sensitive</p>
            <p>• Passwords are case sensitive</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Login;